import type {
  ListInternalLayerVersionsQuery,
  ListInternalLayerVersionsFilter,
} from 'hooks/internalLayerVersion/types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const internalLayerVersionsKeys = {
  all: () => ['internal_layer_versions'] as const,
  list: (query: ListInternalLayerVersionsQuery) => {
    const params =
      buildSearchQueryParams<ListInternalLayerVersionsFilter>(query);
    return [...internalLayerVersionsKeys.all(), 'list', params] as const;
  },
  features: (id: string) =>
    [...internalLayerVersionsKeys.all(), 'features', id] as const,
};
